import * as t from 'io-ts';
import { pipe } from 'fp-ts/function';
import * as E from 'fp-ts/Either';
import * as Err from '@fixtuur/error-context';
import { formatValidationErrors } from 'io-ts-reporters';
import { IOError } from '../base';
import { ModelIdData, Status } from '../base';
/** Attributes of a model item as submitted in a Model PATCH request */
export const Data = t.intersection([
    t.partial(ModelIdData.props),
    t.partial({ notes: t.string, status: Status }),
]);
export const fromUnknown = (item) => {
    return pipe(item, Data.decode, E.mapLeft(formatValidationErrors), E.mapLeft(errorList => Err.construct(IOError.UnableToDecode, {
        errors: JSON.stringify(errorList),
    })));
};
